<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Licitações</h4>
      </v-alert>

      <v-row style="margin-left: 4px">
        <v-col>
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            label="Pesquisar por Assunto"
            v-model="filtro.assunto"
          />
        </v-col>
        <v-col cols="1">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            type="number"
            label="Número"
            v-model="filtro.numero"
          />
        </v-col>
        <v-col cols="1">
          <v-text-field
            v-on:keyup.enter="buscarLicitacao()"
            type="number"
            label="Ano"
            v-model="filtro.ano"
          />
        </v-col>

        <v-col cols="3" style="margin-top: 1.1%">
          <v-select
            solo
            dense
            v-model="filtro.tipoLicitacaoId"
            :items="tiposLic"
            item-text="nome"
            item-value="tipoLicitacaoId"
            label="Tipo de Licitação"
          ></v-select>
        </v-col>

        <v-col cols="2" style="margin-top: 1.8%">
          <v-btn
            style
            color="primary"
            small
            depressed
            :loading="loadingBusca"
            :disabled="loadingBusca"
            @click="buscarLicitacao()"
          >
            <v-icon small>fa-search</v-icon>
          </v-btn>

          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            to="/licitacoes/0"
            :disabled="!userHasPermission()"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>Novo
          </v-btn>
        </v-col>
      </v-row>

      <template>
        <v-data-table
          :headers="headers"
          :items="lista"
          :items-per-page="5"
          :loading="loadingBusca"
          class="elevation-1"
          no-results-text="A busca não trouxe resultados."
          no-data-text="A busca não trouxe resultados."
        >
          <template v-slot:loading>
            <LoadingSpinner text="Carregando licitações... aguarde." />
          </template>
          <template v-slot:item.actions="{ item }">
            <!-- TEMPLATE PARA PASSAR ITEM COMO PARAMETRO PARA AS FUNCOES -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <!-- TEMPLATE PARA ATIVAR TOOLTIP -->
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                  >mdi-pencil</v-icon
                >
              </template>
              <!-- TEMPLATE TOOLTIP -->
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item)"
                  :disabled="!userAdm()"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
          <!-- TEMPLATE DATA-TABLE -->
        </v-data-table>
      </template>

      <v-dialog :retain-focus="false" v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >Confirma a exclusão do item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </app-layout>
</template>

<script>
import licitacaoService from "@/service/LicitacaoService";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      deleteId: null,
      dialogDelete: false,
      loadingBusca: false,
      filtro: {
        numero: null,
        ano: null,
        assunto: null,
        tipoLicitacaoId: null,
      },
      tiposLic: [],
      lista: [],
      headers: [
        { text: "Cód.", value: "licitacaoId", sortable: false },
        { text: "Número", value: "numero", sortable: false },
        { text: "Ano", value: "ano", sortable: false },
        { text: "Tipo", value: "tipoLicitacao.nome", sortable: false },
        {
          text: "Ações",
          value: "actions",
          sortable: false,
          align: "center",
          width: "8%",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.$router.push("/licitacoes/" + item.licitacaoId);
    },
    deleteItem(item) {
      this.deleteId = item.licitacaoId;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteId != null) {
        licitacaoService.excluirLicitacao(this.deleteId);
        this.deleteId = null;
        this.lista = [];
      }
      this.closeDelete();
    },
    buscarLicitacao() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      licitacaoService
        .buscarLicitacaoFiltro(this.filtro)
        .then((result) => (this.lista = result || []))
        .catch(() => (this.lista = []))
        .finally(() => (this.loadingBusca = false));
    },
    findAllTipos() {
      licitacaoService
        .findAllTipos()
        .then((result) => (this.tiposLic = result));
    },
    closeDelete() {
      this.dialogDelete = false;
      this.deleteId = null;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
  },

  mounted() {
    this.findAllTipos();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
